module.exports = "<div [hidden]=\"rows\">\n  loading...\n</div>\n<table class=\"table table-striped\" [hidden]=\"!rows\">\n  <thead>\n    <tr>\n      <th *ngFor='let header of headers'>{{header}}</th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr *ngFor='let row of rows'>\n      <td *ngFor='let item of row'>{{item}}</td>\n    </tr>\n  </tbody>\n</table>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/simple-table.component.html
// module id = 896
// module chunks = 1